/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */


expocadfx.DataLoader = function() {
    var FxEvent = expocadfx.fxevent;
	
    var scriptName = "fxdata.aspx";
    var req = null;
    
//    console.log( "is preview?   " + typeof( expofxPreview));
//    if( !window.expofxPreview) {
//        checkServer();
//    }
	
	setTimeout( function() {		// let expofx.js know we're ready to request files
		document.dispatchEvent( new FxEvent( "Loader_Ready", null));
	}, 0);
	
	
    function loader( file, cb, evtName) {
        var obj = {
            file: file,
            callback: cb,
            eventName: evtName
        };
        
        if( window.expofxPreview) {
            if( cb === null || cb === undefined) {
                console.log( " no callback for   " + file);
            }
            window.expofxPreview.load( obj);
        }
        else {
            sendRequest( obj);
        }
    }
    
    function rptRequestWithScript( fileName, callback) {
        var req2 = null;
        var reqString = "";
		var currentFile = fileName;
		var reqCallback = callback;
		var elem;
        
        reqString = scriptName + "?FileName=" + currentFile;

        if( window.XMLHttpRequest) {
            req2 = new XMLHttpRequest();
        }
        else {
         //   alert( "Could not create request for data");
            swal("", "Could not create request for data!", "error");
            return;
        }
		
        req2.open( 'GET', reqString, true);
		
        req2.onload = function() {
            if( req2.status !== 200 ) {
				if( scriptName === "fxdata.aspx") {
					scriptName = "fxdata.php";
					requestWithScript( fileName, reqCallback);
				}
				else {
					console.log( "Could not access server script for resource  " + currentFile);
					reqCallback( false, null);
				}
            }
            else {
				if( !req2.response) {
					console.log( elem.textContent);
					reqCallback( false, null);
				}
				else {
					reqCallback( true, req2.response);
				}
            }
        };
        req2.send();
    }	

    function requestWithScript( fileName, callback) {
        var req2 = null;
        var reqString = "";
		var currentFile = fileName;
		var reqCallback = callback;
		var elem;
        
        reqString = scriptName + "?FileName=" + currentFile;
		
        if( window.XMLHttpRequest) {
            req2 = new XMLHttpRequest();
        }
        else {
        //    alert( "Could not create request for data");
            swal("", "Could not create request for data!", "error");
            return;
        }
		
        req2.open( 'GET', reqString, true);
		
        req2.onload = function() {
            if( req2.status !== 200 || !req2.responseXML) {
				if( scriptName === "fxdata.aspx") {
					scriptName = "fxdata.php";
					requestWithScript( fileName, reqCallback);
				}
				else {
					console.log( "Could not access server script for resource  " + currentFile);
					reqCallback( false, null);
				}
            }
            else {
				elem = req2.responseXML.getElementsByTagName("FxResp")[0];
				if( elem) {
					console.log( elem.textContent);
					reqCallback( false, null);
				}
				else {
					reqCallback( true, req2.responseXML);
				}
            }
        };
        req2.send();
    }	
    
    function sendRequest( obj) {
        var fileName = obj.file;
        var reqCallback = obj.callback;
        
        if( window.XMLHttpRequest) {
            req = new XMLHttpRequest();
        }
        else {
      //      alert( "Could not create request for data");
            swal("", "Could not create request for data!", "error");
            return;
        }
        
        req.open( 'GET', fileName, true);
        
        req.onload = function() {
            if( this.status === 200 && 
                    this.responseXML !== null && this.responseXML !== undefined ) {
                
				reqCallback( true, this.responseXML);
            }
            else {
                console.log( "File failed to load  " + fileName);
				reqCallback( false, null);
            }
        };
        
        req.send();
    }
    
    return {
        load: loader,
        requestWithScript: requestWithScript,
        rptRequestWithScript: rptRequestWithScript
    };
};